import { render, staticRenderFns } from "./CommercialHomeSections.vue?vue&type=template&id=34f7f612&scoped=true"
import script from "./CommercialHomeSections.vue?vue&type=script&lang=js"
export * from "./CommercialHomeSections.vue?vue&type=script&lang=js"
import style0 from "./CommercialHomeSections.vue?vue&type=style&index=0&id=34f7f612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f7f612",
  null
  
)

export default component.exports